export default "__VITE_ASSET__sLo5wToY__"